import React from 'react'

import clsx from 'clsx'

import Accordion from 'components/Accordion'
import Divider from 'components/Divider'
import { useEventContext } from 'context/EventContext'
import { useListingDetailContext } from 'context/ListingDetailContext'

import TextBase from '../TextBase'

import classes from './Faqs.module.scss'

/** @type {import("./types").default} */
const Faqs = ({ className, questions }) => {
  const { listing } = useListingDetailContext()
  const { sendEvent } = useEventContext()
  return (
    <section className={clsx('Faqs', classes.root, className)}>
      <TextBase title={`${listing.name} FAQs`} />
      {questions.map((faq, index) => (
        <React.Fragment key={`faq_${index}`}>
          <Accordion
            summary={<p className={classes.question}>{`${faq.question}`}</p>}
            summaryClassname={classes.accordionSummary}
            details={<span className={classes.answer} dangerouslySetInnerHTML={{ __html: faq.answer }} />}
            paperProps={{ square: !(index === 0 || index === questions.length - 1) }}
            defaultExpanded={false}
            onExpandClick={(_, { isExpanded }) =>
              sendEvent({
                name: 'engagement_facet_click',
                engagementComponent: 'faqs',
                engagementDestination: !isExpanded ? 'collapse_section' : 'expand_section',
                engagementDetails: isExpanded ? 'chevron_up' : 'chevron_down',
              })
            }
          />
          {index + 1 < questions.length && <Divider className={classes.divider} />}
        </React.Fragment>
      ))}
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: questions.map(({ question, answer }) => ({
              '@type': 'Question',
              name: question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: answer.replace(/<\/?[^>]+(>|$)/g, ''),
              },
            })),
          }),
        }}
      />
    </section>
  )
}
export default Faqs
